import React from 'react';
import { SOCIAL_LOGIN_ENABLED, WEB_OAUTH_PROVIDERS, startOAuth } from '../../config/oauth';
import { AppleIcon, GoogleIcon, KakaoIcon } from '../shared/Icons';

const SNS_LOGIN_BUTTONS = [
  { provider: 'KAKAO', label: '카카오', Icon: KakaoIcon },
  { provider: 'GOOGLE', label: '구글', Icon: GoogleIcon },
  { provider: 'APPLE', label: '애플', Icon: AppleIcon },
] as const;

type GuestGateModalProps = {
  onClose: () => void;
  onProceed: () => void;
  open: boolean;
};

export function GuestGateModal({ onClose, onProceed, open }: GuestGateModalProps) {
  if (!open) {
    return null;
  }

  return (
    <div className="home-guest-modal">
      <div className="home-guest-modal__backdrop" onClick={onClose} />
      <div className="home-guest-modal__dialog" role="dialog" aria-modal="true">
        <div className="home-guest-modal__logo">b</div>
        <div className="home-guest-modal__copy">
          <p className="home-guest-modal__title">안녕하세요 게스트님!</p>
          <p className="home-guest-modal__description">
            10초만에 회원가입하고 밴더의 모든 서비스를 자유롭게 이용해보세요.
          </p>
        </div>
        {/* 소셜 로그인 비노출 시 안내 문구로 대체 (SOCIAL_LOGIN_ENABLED) */}
        {SOCIAL_LOGIN_ENABLED ? (
          <div className="home-guest-modal__socials">
            {SNS_LOGIN_BUTTONS.filter(({ provider }) =>
              WEB_OAUTH_PROVIDERS.includes(provider)
            ).map(({ provider, label, Icon }) => (
              <button aria-label={`${label}로 로그인`} className="login-social__button" key={provider} onClick={() => startOAuth(provider)} type="button">
                <Icon />
              </button>
            ))}
          </div>
        ) : (
          <p className="login-social__label">소셜 로그인은 추후 지원됩니다</p>
        )}
        <button className="home-guest-modal__button" onClick={onProceed} type="button">
          로그인/회원가입 하기
        </button>
      </div>
    </div>
  );
}
